import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef,
  OnDestroy,
  Input,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Organization } from '../../shared/sdk/models';
import { OrganizationService } from '../../organizations/organization.service';
import { CategoryService } from '../category.service';
import { Category } from '../../shared/sdk/models/Category';
import { Subject } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-category-add',
  templateUrl: './category-add.component.html',
  styleUrls: ['./category-add.component.css'],
})
export class CategoryAddComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() category: Category;
  @ViewChild('categoryName', { static: true }) categoryName: ElementRef;
  categoryForm: FormGroup;
  sent: boolean;
  private activeOrg: Organization;
  private onDestroy = new Subject<void>();

  constructor(
    private activeModal: NgbActiveModal,
    private orgService: OrganizationService,
    private categoryService: CategoryService,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    this.categoryForm = this.fb.group({
      name: ['', Validators.required],
      alias: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[a-z0-9_-]*$'),
        ]),
      ],
      // TODO: Validate unique alias
      custom: [],
    });

    if (!this.category) {
      this.category = new Category();
    } else {
      this.category = new Category(this.category);
      this.categoryForm.patchValue(this.category);
    }

    this.orgService.active
      .pipe(
        filter(org => !!org),
        takeUntil(this.onDestroy),
      )
      .subscribe(
        (org: Organization) => {
          this.activeOrg = org;
        },
      );
  }

  ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => this.categoryName.nativeElement.focus(), 100);
  }

  onClose() {
    this.activeModal.dismiss();
  }

  onSave() {
    this.sent = true;

    if (this.categoryForm.valid) {
      const categoryFormValue = this.categoryForm.value;
      const editing = !!this.category.id;

      this.categoryService[!editing ? 'create' : 'update'](
        !editing ? this.activeOrg.id : this.category.id,
        categoryFormValue,
      ).subscribe((category) => {
        this.activeModal.close(category);
      });
    }
  }
}
